import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-quantity-limit-dialog',
  templateUrl: './quantity-limit-dialog.component.html',
  styleUrls: ['./quantity-limit-dialog.component.scss'],
})
export class QuantityLimitDialogComponent {
  constructor(public dialogRef: MatDialogRef<QuantityLimitDialogComponent> , @Inject(MAT_DIALOG_DATA) public data: any) {}
  closeDialog(): void {
    this.dialogRef.close();
    
  }
}
